import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router";
import { Button } from "react-bootstrap";

import AnlagenpassContainer from "./AnlagenpassContainer";
import UebersichtKompressorContainer from "./UebersichtKompressorContainer";

import "./Kompressorsteuerung.css";

const Kompressorsteuerung = props => (
	<div className="Kompressorsteuerung">
		<div>
			<div>
				<Button className="AnlagenpassButton almig-image-button"
					onClick={() => props.showAnlagenpass(props.location_path)}/>
				<Button className="almig-previous-button almig-image-button"
					disabled={props.previous_index === -1}
					onClick={() => props.gotoCompressor(
						props.location_path, props.previous_index)} />
				<Button className="almig-next-button  almig-image-button"
					disabled={props.next_index === -1}
					onClick={() => props.gotoCompressor(
						props.location_path, props.next_index)} />
			</div>
		</div>
		<Switch>
			<Route path="/overview/compressor/:compressorIndex/type_plate" component={AnlagenpassContainer} />
			<Route path="/overview/compressor/:compressorIndex" component={UebersichtKompressorContainer} />
			<Redirect exact from="/overview/compressor" to={props.default_path} />
		</Switch>
	</div>
);

Kompressorsteuerung.propTypes = {
	location_path: PropTypes.string.isRequired,
	default_path: PropTypes.string.isRequired,
	previous_index: PropTypes.number.isRequired,
	next_index: PropTypes.number.isRequired,
	showAnlagenpass: PropTypes.func.isRequired,
	gotoCompressor: PropTypes.func.isRequired
};

export default Kompressorsteuerung;
